module.exports = __webpack_public_path__ + "static/media/collingwood.1d3d46d5.svg";